import { HttpClient } from '../../../api/httpClient';
import { API_URL } from '../../../api/RestAPI';
import apiHeaders from '../../../api/apiHeaders';
import { setUrlForGetRequest } from '../../../api/sharedFunctions';

const CATEGORY_API = `${API_URL}/categories`;

const createCategory = (category, storeId) => {
  const url = storeId ? `${CATEGORY_API}/create?store_id=${storeId}` : `${CATEGORY_API}/create`;
  return HttpClient.post(url, category, apiHeaders());
};

const getCategories = (params, dependent = {}) => {
  let url = setUrlForGetRequest(CATEGORY_API, params);
  return HttpClient.get(url, apiHeaders(dependent));
};

const getCategory = (id, storeId) => {
  const url = storeId ? `${CATEGORY_API}/${id}?store_id=${storeId}` : `${CATEGORY_API}/${id}`;
  return HttpClient.get(url, apiHeaders());
};

const updateCategory = (id, category, storeId) => {
  const url = storeId ? `${CATEGORY_API}/${id}/update?store_id=${storeId}` : `${CATEGORY_API}/${id}/update`;
  return HttpClient.put(url, category, apiHeaders());
};

const removeCategory = (category, storeId) => {
  const url = storeId ? `${CATEGORY_API}/${category.id}?store_id=${storeId}` : `${CATEGORY_API}/${category.id}`;
  return HttpClient.delete(url, apiHeaders());
};

const CategoryApi = { getCategories, createCategory, getCategory, updateCategory, removeCategory };

export { CategoryApi };